import React from "react";
import Admin from "../Admin";
import CardAdminTermGeneral from "../../../Component/Card/Admin/Term/CardAdminTermGeneral";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIListItemIcon from "@mui/material/ListItemIcon";
import api from "../../../Seating/Security/api";
import Validator from "../../../Utility/Validator";
import Term from "../../../Utility/Crud/Term";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

export default class AdminTermCreateEditTerms extends Admin {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      term: null,
      isProcessing: false,
      isUpdate: !!props.match.params.id,
      confirmDialogOpen: false,
      validationIssues: {},
      selectedType: "",
      typeInputValue: "",
    };
  }

  afterComponentDidMount() {
    const termId = this.props.match.params.id
      ? +this.props.match.params.id
      : null;
    const typeOptions = this.getTypeOptions();

    if (termId !== null) {
      const term = this.context.termsIndexed[termId];
      this.setState({
        term: term,
        selectedType: term
          ? term.type
          : typeOptions[0]
            ? typeOptions[0].value
            : "",
        typeInputValue: term ? this.getTypeLabel(term.type) : "",
      });
    } else {
      this.setState({
        term: { name: "" },
        selectedType: "",
        typeInputValue: "",
      });
    }
  }

  getTypeOptions() {
    const optionsByType = {};

    Object.entries(Term.getTermTypes()).forEach(([type, data]) => {
      optionsByType[type] = type;
    });

    Object.values(this.context.termsIndexed || {}).forEach((term) => {
      if (term && term.type && !optionsByType[term.type]) {
        optionsByType[term.type] = term.type;
      }
    });

    return Object.keys(optionsByType)
      .sort((a, b) => optionsByType[a].localeCompare(optionsByType[b]))
      .map((type) => ({
        value: type,
        label: optionsByType[type],
      }));
  }

  getTypeLabel(type) {
    if (!type) {
      return "Term";
    }

    const knownType = Term.getTermTypes()[type];
    if (knownType && knownType.name) {
      return knownType.name;
    }

    return type
      .split("_")
      .filter((part) => part.length > 0)
      .map((part) => part[0].toUpperCase() + part.slice(1))
      .join(" ");
  }

  normalizeType(value) {
    return (value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
  }

  getType() {
    if (this.state.isUpdate) {
      return this.state.term ? this.state.term.type : null;
    }

    return (
      this.state.selectedType || this.normalizeType(this.state.typeInputValue)
    );
  }

  async createTerm() {
    this.setState({
      isProcessing: true,
    });

    return api
      .send("POST", "/terms", {
        ...this.state.term,
        type: this.getType(),
      })
      .then((term) => {
        this.context.updateIndexed("termsIndexed", term);
        this.props.history.push(`/admin/terms`);
        NotistackEnqueueSnackbar("Term created successfully!", {
          variant: "success",
        });
        this.setState({
          isProcessing: false,
          isUpdate: true,
          term: term,
        });
      })
      .catch(() => {
        this.setState({
          isProcessing: false,
        });
        NotistackEnqueueSnackbar(
          "Oh no! There was an error creating the term.",
          { variant: "error" },
        );
      });
  }

  async updateTerm() {
    this.setState({
      isProcessing: true,
    });

    return api
      .send("PUT", "/terms", this.state.term)
      .then((term) => {
        this.context.updateIndexed("termsIndexed", term);
        this.props.history.push("/admin/terms");
        this.setState({
          term: term,
          isProcessing: false,
        });
        NotistackEnqueueSnackbar("Term updated successfully!", {
          variant: "success",
        });
      })
      .catch(() => {
        this.setState({
          isProcessing: false,
        });
        NotistackEnqueueSnackbar(
          "Oh no! There was an error updating the term.",
          { variant: "error" },
        );
      });
  }

  async deleteTerm() {
    if (!this.state.term || !this.state.term.id) {
      return;
    }

    this.setState({
      isProcessing: true,
    });

    return api
      .send("DELETE", `/terms/${this.state.term.id}`)
      .then(() => {
        this.context.deleteIndexed("termsIndexed", this.state.term.id);
        this.props.history.push("/admin/terms");
        NotistackEnqueueSnackbar("Term deleted successfully!", {
          variant: "success",
        });
      })
      .catch(() => {
        this.setState({
          confirmDialogOpen: false,
          isProcessing: false,
        });
        NotistackEnqueueSnackbar(
          "Oh no! There was an error deleting the term.",
          { variant: "error" },
        );
      });
  }

  renderContent() {
    const handleChange = (term) => {
      this.setState({
        term: {
          ...this.state.term,
          ...term,
        },
      });
    };

    const typeLabel = this.getTypeLabel(this.getType());

    return (
      <>
        <CardAdminTermGeneral
          term={this.state.term}
          onChange={handleChange.bind(this)}
          validationIssues={this.state.validationIssues}
          typeOptions={this.getTypeOptions()}
          selectedType={this.state.selectedType}
          typeInputValue={this.state.typeInputValue}
          showTypeField={!this.state.isUpdate}
          showTypeReadOnly={this.state.isUpdate}
          typeValue={this.state.term ? this.state.term.type : ""}
          onTypeChange={(option) => {
            if (typeof option === "string") {
              this.setState({
                selectedType: this.normalizeType(option),
                typeInputValue: option,
                validationIssues: {
                  ...this.state.validationIssues,
                  type: null,
                },
              });
              return;
            }

            this.setState({
              selectedType: option ? option.value : "",
              typeInputValue: option ? option.label : "",
              validationIssues: {
                ...this.state.validationIssues,
                type: null,
              },
            });
          }}
          onTypeInputChange={(value, reason) => {
            if (reason === "input") {
              this.setState({
                typeInputValue: value,
                selectedType: "",
                validationIssues: {
                  ...this.state.validationIssues,
                  type: null,
                },
              });
              return;
            }

            this.setState({
              typeInputValue: value,
              validationIssues: {
                ...this.state.validationIssues,
                type: null,
              },
            });
          }}
        />
        <DialogConfirm
          open={this.state.confirmDialogOpen}
          onClose={() => this.setState({ confirmDialogOpen: false })}
          onConfirm={() => this.deleteTerm()}
          text={`Are you sure you want to delete this ${typeLabel}? This cannot be undone.`}
          header={`Delete ${typeLabel}`}
          loading={this.state.isProcessing}
        />
      </>
    );
  }

  renderHeader() {
    const buttonText = this.state.isUpdate ? "Save" : "Create";
    const typeLabel = this.getType();
    const title = this.state.isUpdate
      ? `Edit ${typeLabel}`
      : `Create ${typeLabel}`;
    const subtitle =
      this.state.isUpdate && this.state.term
        ? `${this.state.term.name} • ${this.state.term.id}`
        : null;

    const handleClickSave = () => {
      const payload = {
        ...this.state.term,
        type: this.getType(),
      };
      const validationIssues = Validator.validate(payload, {
        name: {
          required: true,
        },
        type: {
          required: true,
        },
      });

      this.setState({
        validationIssues,
      });

      if (Object.keys(validationIssues).length > 0) {
        NotistackEnqueueSnackbar("Please correct the displayed issues.", {
          variant: "error",
        });
        return;
      }

      if (this.state.isUpdate) {
        this.updateTerm();
      } else {
        this.createTerm();
      }
    };

    const buttons = [
      <MUIButton onClick={() => this.props.history.push("/admin/terms")}>
        Back
      </MUIButton>,
      <MUILoadingButton
        loading={this.state.isProcessing}
        loadingPosition="start"
        onClick={handleClickSave}
        variant="contained"
        startIcon={<MUISaveButton />}
      >
        {buttonText}
      </MUILoadingButton>,
    ];

    if (this.state.isUpdate) {
      const menuItems = [
        <MUIMenuItem onClick={() => this.setState({ confirmDialogOpen: true })}>
          <MUIListItemIcon>
            <MUIDeleteIcon fontSize="small" />
          </MUIListItemIcon>
          Delete
        </MUIMenuItem>,
      ];

      buttons.push(<Menu menuItems={menuItems} />);
    }

    return <PageHeader title={title} subtitle={subtitle} buttons={buttons} />;
  }
}
